var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk061212120(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 174.2 30",
    style: {
      enableBackground: "new 0 0 174.2 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 129.1,
    y: -6.8,
    transform: "matrix(0.4702 -0.8825 0.8825 0.4702 61.9945 118.3208)",
    width: 1,
    height: 28.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.4,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 6.5875 67.4705)",
    width: 28.7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.7,
    y: 11,
    width: 3.6,
    height: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.1,30H116V0h30.1V30z M117,29h28.2V1H117V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.7,25.9H120V3.7h22.7V25.9z M120.9,24.9h20.8V4.7h-20.8V24.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.1,
    y: -6.8,
    transform: "matrix(0.4704 -0.8824 0.8824 0.4704 0.5506 15.9591)",
    width: 1,
    height: 28.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -8.8206 9.7042)",
    width: 28.7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.8,
    y: 11,
    width: 3.6,
    height: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,30H0V0h30.1V30z M1,29h28.2V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7,25.9H4V3.7h22.7V25.9z M5,24.9h20.8V4.7H5V24.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: -6.8,
    transform: "matrix(0.4702 -0.8825 0.8825 0.4702 15.8552 41.4554)",
    width: 1,
    height: 28.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.3,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -4.9825 24.0937)",
    width: 28.7,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,30H28.9V0H59V30z M29.9,29h28.2V1H29.9V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6,25.9H32.9V3.7h22.7V25.9z M33.8,24.9h20.8V4.7H33.8V24.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: -6.8,
    transform: "matrix(0.4704 -0.8824 0.8824 0.4704 31.3008 67.1979)",
    width: 1,
    height: 28.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -1.1073 38.6221)",
    width: 28.7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.8,
    y: 11,
    width: 3.6,
    height: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2,30H58.1V0h30.1V30z M59,29h28.2V1H59V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8,25.9H62V3.7h22.7V25.9z M63,24.9h20.8V4.7H63V24.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: -6.8,
    transform: "matrix(0.4702 -0.8825 0.8825 0.4702 46.6147 92.6989)",
    width: 1,
    height: 28.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.4,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 2.7308 53.0115)",
    width: 28.7,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.1,30H87V0h30.1V30z M87.9,29h28.2V1H87.9V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.6,25.9H90.9V3.7h22.7V25.9z M91.9,24.9h20.8V4.7H91.9V24.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.1,
    y: -6.8,
    transform: "matrix(0.4702 -0.8825 0.8825 0.4702 77.3744 143.9428)",
    width: 1,
    height: 28.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 10.4442 81.9294)",
    width: 28.7,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.2,30H145V0h30.1V30z M146,29h28.2V1H146V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.7,25.9H149V3.7h22.7V25.9z M150,24.9h20.8V4.7H150V24.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk061212120);
export default __webpack_public_path__ + "static/media/AK0_6_121212_0.dcbc0fc145b783f8d1084ba411538c6b.svg";
export { ForwardRef as ReactComponent };